import React from 'react'
import ReviewDrawer from '../Drawer/ReviewDrawer'
import Searchbar from 'app/components/Searchbar'

interface FilterBarProps {
  searchTerm: string
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>
  owners: any[]
  selectedPlatform: string
  setSelectedPlatform: (reviewer: string) => void
  selectedStatus: string
  setSelectedStatus: (status: string) => void
  handleInputChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  type?: string
}

const ReviewFilterBar: React.FC<FilterBarProps> = ({
  searchTerm,
  setSearchTerm,
  owners,
  selectedPlatform,
  setSelectedPlatform,
  selectedStatus,
  setSelectedStatus,
  handleInputChange,
  type,
}) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false)

  const handleOpenModal = () => {
    setIsModalOpen(true)
  }

  return (
    <>
      <div className='card-header border-0 pt-6 h-100'>
        <div className='card-title gap-sm-4'>
        <div className='flex-lg-fill'>
            <Searchbar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        </div>
          {type === 'review' && (
            <>
              <div className='dropdown'>
                <button
                  className='btn btn-outline px-4 fw-normal'
                  type='button'
                  id='ownerDropdown'
                  data-bs-toggle='dropdown'
                  aria-expanded='false'
                  style={{color: '#111928'}}
                >
                  {selectedPlatform || 'Reviewer'}
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='20'
                    height='20'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='currentColor'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    className='icon icon-tabler icons-tabler-outline icon-tabler-chevron-down rotate-180 ms-2'
                  >
                    <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                    <path d='M6 9l6 6l6 -6' />
                  </svg>
                </button>
                <ul className='dropdown-menu' aria-labelledby='ownerDropdown'>
                  <li>
                    <a className='dropdown-item' href='#' onClick={() => setSelectedPlatform('')}>
                      All Reviewers
                    </a>
                  </li>
                  {owners.map((owner) => (
                    <li key={owner.id}>
                      <a
                        className='dropdown-item'
                        href='#'
                        onClick={() => setSelectedPlatform(owner.full_name)}
                      >
                        {owner.full_name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <div className='dropdown'>
                <button
                  className='btn btn-outline d-flex align-items-center gap-3 px-4 fw-normal'
                  type='button'
                  id='statusDropdown'
                  data-bs-toggle='dropdown'
                  aria-expanded='false'
                >
                  {selectedStatus || 'Status'}
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='20'
                    height='20'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='currentColor'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    className='icon icon-tabler icons-tabler-outline icon-tabler-chevron-down rotate-180'
                  >
                    <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                    <path d='M6 9l6 6l6 -6' />
                  </svg>
                </button>
                <ul className='dropdown-menu w-100' aria-labelledby='statusDropdown'>
                  <li>
                    <a
                      className='dropdown-item d-flex align-items-center gap-2'
                      href='#'
                      onClick={() => setSelectedStatus('')}
                    >
                      All Status
                    </a>
                  </li>
                  <li>
                    <a
                      className='dropdown-item d-flex align-items-center gap-2'
                      href='#'
                      onClick={() => setSelectedStatus('In review')}
                    >
                      In review
                    </a>
                  </li>
                  <li>
                    <a
                      className='dropdown-item d-flex align-items-center gap-2'
                      href='#'
                      onClick={() => setSelectedStatus('Pending')}
                    >
                      Pending
                    </a>
                  </li>

                  <li>
                    <a
                      className='dropdown-item d-flex align-items-center gap-2'
                      href='#'
                      onClick={() => setSelectedStatus('Completed')}
                    >
                      Completed
                    </a>
                  </li>
                  <li>
                    <a
                      className='dropdown-item d-flex align-items-center gap-2'
                      href='#'
                      onClick={() => setSelectedStatus('Due')}
                    >
                      Due
                    </a>
                  </li>
                </ul>
              </div>
            </>
          )}
        </div>
        {type === 'review' ? (
          <div className='card-toolbar d-flex align-items-center gap-3'>
            <button
              className='btn btn-sm fs-6'
              style={{background: '#0E9F6E', height: '40px', color: '#fff'}}
              onMouseEnter={(e: React.MouseEvent<HTMLElement>) =>
                (e.currentTarget.style.backgroundColor = '#148363')
              }
              onMouseLeave={(e: React.MouseEvent<HTMLElement>) =>
                (e.currentTarget.style.backgroundColor = '#0E9F6E')
              }
              onClick={handleOpenModal}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='20'
                height='20'
                viewBox='0 0 24 24'
                fill='none'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
                className='icon icon-tabler icons-tabler-outline icon-tabler-plus'
              >
                <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                <path d='M12 5l0 14' />
                <path d='M5 12l14 0' />
              </svg>
              <span className='mx-2'>Add Review</span>
            </button>
          </div>
        ) : (
          ''
        )}
      </div>

      <ReviewDrawer isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  )
}

export default ReviewFilterBar
